import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { NotificacoesColumns } from './columns/_columns'
import { NotificacaoList } from '../../core/_models'

export const NotificacoesTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhuma notificação não lida'
      description='Você já leu todas as suas notificações.'
      action={{ label: 'Mostrar todas', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma notificação'
      description='As notificações enviadas para você aparecem aqui.'
    />
  )

  return (
    <CustomTable<NotificacaoList>
      id='kt_table_notificacoes'
      ariaLabel='Notificações'
      itemLabel={{ singular: 'notificação', plural: 'notificações' }}
      data={response?.data || []}
      columns={NotificacoesColumns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
